import TypedNativeModules from "../internal/TypedNativeModules";
import type { ElementType } from "../types/TareBridge";

export async function logElementView(
  screenName: string,
  elementName: string,
  elementType: ElementType,
  tags: string[] = [],
  extraParams: Record<string, string | number | boolean> = {},
): Promise<void> {
  const tareBridge = TypedNativeModules.RNTareBridge;
  if (!tareBridge?.logElementView) {
    return;
  }
  await tareBridge.logElementView(screenName, elementName, elementType, tags, extraParams);
}
